module.exports = __webpack_public_path__ + "img/cvc.79d045a6.svg";